import { Routes } from '@angular/router';
import { HomeComponent } from './amm-pages/home/home.component';
import { addressResolver, forceLoginGuard } from './amm-share/guards';
import { ShippingAddressResolver } from './amm-share/guards/shippingAddressResolver';

const routeConfig: Routes = [
  {
    path: 'details/:code',
    loadComponent: () =>
      import('../app/amm-pages/details/details.component').then(
        (m) => m.DetailsComponent
      ),
    title: 'Product details',
  },
  {
    path: 'store/:code',
    loadComponent: () =>
      import('../app/amm-pages/page-store/page-store.component').then(
        (m) => m.PageStoreComponent
      ),
    title: 'Store',
  },
  {
    path: 'message',
    canActivate: [forceLoginGuard],
    loadComponent: () =>
      import('../app/amm-pages/page-message/page-message.component').then(
        (m) => m.PageMessageComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            '../app/amm-share/components/no-converstaion-selected/no-converstaion-selected.component'
          ).then((m) => m.NoConverstaionSelectedComponent),
      },
      {
        path: ':topmsgId',
        loadComponent: () =>
          import(
            '../app/amm-pages/message-content/message-content.component'
          ).then((m) => m.MessageContentComponent),
      },
    ],
    title: 'Message',
  },
  {
    path: 'check-out',
    loadComponent: () =>
      import('../app/amm-pages/check-out/check-out.component').then(
        (m) => m.CheckOutComponent
      ),
    resolve: { resolvedData: ShippingAddressResolver },
    title: 'check out',
  },
  {
    path: 'page-policy',
    loadComponent: () =>
      import('../app/amm-pages/page-policy/page-policy.component').then(
        (m) => m.PagePolicyComponent
      ),
    title: 'Page policy',
  },
  {
    path: 'legal-docs/:documentType',
    loadComponent: () =>
      import('../app/amm-pages/legal-doc/legal-doc.component').then(
        (m) => m.LegalDocComponent
      ),
    title: 'Legal doc',
  },
  // {
  //   path: 'help-center-article/:documentDir',
  //   loadComponent: () =>
  //     import('../app/amm-pages/legal-doc/legal-doc.component').then(
  //       (m) => m.LegalDocComponent,
  //     ),
  //   title: 'Help center article',
  // },
  {
    path: 'help-center-article/:documentDir/:fileName',
    loadComponent: () =>
      import(
        '../app/amm-pages/help-center-article/help-center-article.component'
      ).then((m) => m.HelpCenterArticleComponent),
    title: 'Help center article',
  },
  {
    path: 'about',
    loadComponent: () =>
      import('../app/amm-pages/about/about.component').then(
        (m) => m.AboutComponent
      ),

    title: 'About us',
  },
  {
    path: 'help-center',
    loadComponent: () =>
      import('../app/amm-pages/help-center/help-center.component').then(
        (m) => m.HelpCenterComponent
      ),
    title: 'Help center',
  },
  {
    path: 'mobile-register',
    loadComponent: () =>
      import('../app/amm-pages/mobile-register/mobile-register.component').then(
        (m) => m.MobileRegisterComponent
      ),
    title: 'Mobile Register',
  },
  {
    path: 'mobile-register/error',
    loadComponent: () =>
      import('../app/amm-pages/mobile-register/mobile-register.component').then(
        (m) => m.MobileRegisterComponent
      ),
    title: 'Mobile Register',
  },
  {
    path: 'register',
    loadComponent: () =>
      import('../app/amm-pages/page-register/page-register.component').then(
        (m) => m.PageRegisterComponent
      ),
    title: 'Register',
  },
  {
    path: 'quick-product-view',
    loadComponent: () =>
      import(
        '../app/amm-pages/product-quick-view/product-quick-view.component'
      ).then((m) => m.ProductQuickViewComponent),
  },
  {
    path: 'new-home',
    loadComponent: () =>
      import('../app/amm-pages/new-homepage/new-homepage.component').then(
        (m) => m.NewHomepageComponent
      ),
    title: 'New homepage'
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../app/amm-pages/new-homepage/new-homepage.component').then(
            (m) => m.NewHomepageComponent
          ),
      },

      // {
      //   path: '',
      //   loadComponent: () =>
      //     import('../app/amm-pages/main-page/main-page.component').then(
      //       (m) => m.MainPageComponent
      //     ),
      //
      // },

      // {
      //   path: 'new-home',
      //   loadComponent: () =>
      //     import('../app/amm-pages/new-homepage/new-homepage.component').then(
      //       (m) => m.NewHomepageComponent
      //     ),
      //
      // },

      {
        path: 'search-result',
        loadComponent: () =>
          import('../app/amm-pages/search-result/search-result.component').then(
            (m) => m.SearchResultComponent
          ),
      },
      {
        path: 'favorites',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import('../app/amm-pages/favorites/favorites.component').then(
            (m) => m.FavoritesComponent
          ),
        title: 'Favorites',
      },
      {
        path: 'shopping-carts',
        loadComponent: () =>
          import(
            '../app/amm-pages/shopping-carts/shopping-carts.component'
          ).then((m) => m.ShoppingCartsComponent),
        title: 'Shopping Carts',
      },
      {
        path: 'orders',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import('../app/amm-pages/orders/orders.component').then(
            (m) => m.OrdersComponent
          ),
        title: 'Orders',
      },
      {
        path: 'packages/:poNumber',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import('../app/amm-pages/order-package/order-package.component').then(
            (m) => m.PageOrderPackageComponent
          ),
        title: 'Order Packages',
      },
      {
        path: 'orders/:poNumber',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import('../app/amm-pages/order-details/order-details.component').then(
            (m) => m.OrderDetailsComponent
          ),
        title: 'Orders',
      },
      {
        path: 'login-security',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import(
            '../app/amm-pages/login-security/login-security.component'
          ).then((m) => m.LoginSecurityComponent),
        title: 'Login security',
      },
      {
        path: 'address',
        canActivate: [forceLoginGuard],
        loadComponent: () =>
          import('../app/amm-pages/page-address/page-address.component').then(
            (m) => m.PageAddressComponent
          ),
        title: 'Address',
      },
      {
        path: 'order-confirm',
        loadComponent: () =>
          import('../app/amm-pages/order-confirm/order-confirm.component').then(
            (m) => m.OrderConfirmComponent
          ),
        title: 'Order Confirmation',
      },
    ],
    title: 'Ammall Shopping',
  },
];

export default routeConfig;
